import React from 'react';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-white pt-20">
      {/* Hero Section */}
      <section className="bg-black text-white py-20">
        <div className="max-w-[1920px] mx-auto px-6 lg:px-12">
          <h1 className="text-5xl lg:text-6xl font-bold tracking-tight mb-6">
            Datenschutzerklärung
          </h1>
          <p className="text-xl text-white/80 max-w-2xl">
            Informationen zum Schutz Ihrer personenbezogenen Daten
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          {/* Verantwortlicher */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">Verantwortlicher im Sinne der DSGVO</h2>
            <div className="text-gray-700 space-y-1">
              <p className="font-semibold">Positiv Fitness Wolnzach GmbH</p>
              <p>Preysingstraße 64</p>
              <p>85283 Wolnzach</p>
              <p>Deutschland</p>
              <p className="mt-4">Telefon: 08442/677300</p>
              <p>E-Mail: wolnzach@positiv-gruppe.de</p>
              <p>USt-IdNr.: DE269219376</p>
            </div>
          </div>

          {/* 1. Allgemeine Hinweise */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">1. Allgemeine Hinweise</h2>
            <p className="text-gray-700 leading-relaxed">
              Wir nehmen den Schutz Ihrer personenbezogenen Daten sehr ernst. Personenbezogene Daten 
              werden von uns nur im notwendigen Umfang und auf Grundlage einer gesetzlichen Erlaubnis 
              oder Ihrer Einwilligung verarbeitet. Diese Datenschutzerklärung erläutert Art, Umfang und 
              Zweck der Verarbeitung auf unserer Website sowie im Zusammenhang mit Mitgliedschaften.
            </p>
          </div>

          {/* 2. Begriffe */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">2. Begriffe</h2>
            <p className="text-gray-700 leading-relaxed">
              „Personenbezogene Daten" sind alle Informationen, die sich auf eine identifizierte oder 
              identifizierbare natürliche Person beziehen (Art. 4 Nr. 1 DSGVO).
            </p>
          </div>

          {/* 3. Ihre Rechte */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">3. Ihre Rechte</h2>
            <p className="text-gray-700 leading-relaxed">
              Sie haben – soweit die gesetzlichen Voraussetzungen vorliegen – folgende Rechte: 
              Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16 DSGVO), Löschung (Art. 17 DSGVO), 
              Einschränkung der Verarbeitung (Art. 18 DSGVO), Datenübertragbarkeit (Art. 20 DSGVO), 
              Widerspruch gegen Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. e/f DSGVO (Art. 21 DSGVO) 
              sowie Widerruf erteilter Einwilligungen (Art. 7 Abs. 3 DSGVO). Zudem haben Sie ein 
              Beschwerderecht bei einer Datenschutzaufsichtsbehörde (Art. 77 DSGVO).
            </p>
          </div>

          {/* 4. Website-Zugriff */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">4. Website-Zugriff (Server-Logfiles)</h2>
            <p className="text-gray-700 leading-relaxed">
              Beim Aufruf unserer Website werden durch den Webserver automatisch Informationen erhoben 
              und in sogenannten Server-Logfiles gespeichert. Dies können insbesondere sein: IP-Adresse, 
              Datum/Uhrzeit des Zugriffs, aufgerufene Seite/Datei, Referrer-URL, Browsertyp/-version, 
              Betriebssystem, Hostname. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse 
              an Sicherheit, Stabilität und Fehleranalyse). Logfiles werden grundsätzlich nur so lange 
              gespeichert, wie dies für die genannten Zwecke erforderlich ist.
            </p>
          </div>

          {/* 5. Cookies */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">5. Cookies / Einwilligungsmanagement</h2>
            <p className="text-gray-700 leading-relaxed">
              Unsere Website kann Cookies oder vergleichbare Technologien einsetzen. Technisch 
              notwendige Cookies können auf Grundlage von § 25 Abs. 2 TTDSG gesetzt werden. Für alle 
              anderen Cookies (z. B. Statistik/Marketing) holen wir – sofern eingesetzt – eine Einwilligung 
              gemäß § 25 Abs. 1 TTDSG i. V. m. Art. 6 Abs. 1 lit. a DSGVO ein. Sie können Ihre Einwilligungen 
              jederzeit über die Cookie-Einstellungen widerrufen.
            </p>
          </div>

          {/* 6. Kontaktaufnahme */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">6. Kontaktaufnahme</h2>
            <p className="text-gray-700 leading-relaxed">
              Wenn Sie uns per E-Mail oder über ein Kontaktformular kontaktieren, verarbeiten wir die von 
              Ihnen mitgeteilten Daten (z. B. Name, E-Mail-Adresse, Inhalt der Nachricht) zur Bearbeitung 
              Ihres Anliegens. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche/vertragliche 
              Kommunikation) bzw. Art. 6 Abs. 1 lit. f DSGVO (allgemeine Anfragen).
            </p>
          </div>

          {/* 7. Mitgliedschaft */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">7. Mitgliedschaft, Studioverwaltung & SEPA-Lastschrift</h2>
            <p className="text-gray-700 leading-relaxed">
              Im Rahmen von Mitgliedschaften verarbeiten wir Stammdaten (z. B. Name, Anschrift, 
              Geburtsdatum), Kontaktdaten, Vertrags-/Tarifdaten, Zutritts-/Nutzungsdaten sowie 
              Zahlungsdaten. Zahlungen erfolgen per SEPA-Lastschrift. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b 
              DSGVO (Vertragserfüllung). Zur Verwaltung können wir ein Studio-/Mitgliederverwaltungssystem 
              (z. B. „Athletics") einsetzen. Soweit hierbei Dienstleister als Auftragsverarbeiter tätig werden, 
              erfolgt dies auf Grundlage eines Vertrags zur Auftragsverarbeitung gemäß Art. 28 DSGVO.
            </p>
          </div>

          {/* 8. Empfänger */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">8. Empfänger / Auftragsverarbeiter</h2>
            <p className="text-gray-700 leading-relaxed">
              Wir geben personenbezogene Daten nur weiter, wenn dies zur Vertragserfüllung erforderlich ist, 
              eine gesetzliche Pflicht besteht oder Sie eingewilligt haben. Mögliche Empfänger sind 
              insbesondere IT- und Hostingdienstleister, Anbieter der Mitgliederverwaltung, 
              Zahlungsdienstleister/Banken sowie Steuerberater. Dienstleister werden – soweit erforderlich – 
              vertraglich nach Art. 28 DSGVO verpflichtet.
            </p>
          </div>

          {/* 9. Speicherdauer */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">9. Speicherdauer</h2>
            <p className="text-gray-700 leading-relaxed">
              Wir speichern personenbezogene Daten grundsätzlich nur so lange, wie es für die jeweiligen 
              Zwecke erforderlich ist. Darüber hinaus speichern wir Daten, soweit gesetzliche 
              Aufbewahrungspflichten bestehen (z. B. handels- und steuerrechtliche Aufbewahrungspflichten).
            </p>
          </div>

          {/* 10. Datensicherheit */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">10. Datensicherheit</h2>
            <p className="text-gray-700 leading-relaxed">
              Wir treffen angemessene technische und organisatorische Maßnahmen, um Ihre Daten gegen 
              Verlust, Manipulation und unberechtigte Zugriffe zu schützen.
            </p>
          </div>

          {/* 11. Aktualität */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">11. Aktualität</h2>
            <p className="text-gray-700 leading-relaxed">
              Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um sie an geänderte Rechtslagen 
              oder bei Änderungen unserer Leistungen anzupassen.
            </p>
          </div>

          {/* Stand */}
          <div className="border-t pt-8 mt-12">
            <p className="text-gray-500 text-sm">
              Stand: Februar 2026
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
